<template>
  <div class="text-center py-3 mt-3 social-icons">
    <a href="https://linkedin.com/company/grupoapok" target="_blank" class="icon">
      <font-awesome-layers class="fa-2x">
        <font-awesome-icon icon="circle" class="circle"/>
        <font-awesome-icon :icon="['fab', 'linkedin-in']" transform="shrink-6"/>
      </font-awesome-layers>
    </a>
    <a href="https://www.facebook.com/grupoapok/" target="_blank" class="icon">
      <font-awesome-layers class="fa-2x">
        <font-awesome-icon icon="circle" class="circle"/>
        <font-awesome-icon :style="{color: '#'+bg}" :icon="['fab', 'facebook-f']" transform="shrink-6"/>
      </font-awesome-layers>
    </a>
    <a href="https://twitter.com/grupoapok" target="_blank" class="icon">
      <font-awesome-layers class="fa-2x">
        <font-awesome-icon icon="circle" class="circle"/>
        <font-awesome-icon :style="{color: '#'+bg}" :icon="['fab', 'twitter']" transform="shrink-6"/>
      </font-awesome-layers>
    </a>
    <a href="https://www.instagram.com/grupoapok" target="_blank" class="icon">
      <font-awesome-layers class="fa-2x">
        <font-awesome-icon icon="circle" class="circle"/>
        <font-awesome-icon :style="{color: '#'+bg}" :icon="['fab', 'instagram']" transform="shrink-6"/>
      </font-awesome-layers>
    </a>
  </div>
</template>

<script>
  import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'

  export default {
    name: 'SocialIcons',
    components: { FontAwesomeIcon, FontAwesomeLayers },
    data (){
      return {
        bg: '',
      }
    },
  }
</script>

<style scoped lang="scss">
  @import "../assets/styles/colors.scss";
  .social-icons{
    border-top: 1px solid rgba(255, 255, 255, 0.71);
  }

  .fa-layers{
    color: $dark-blue-3;
  .circle{
    color: rgba(255, 255, 255, 0.8);
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/SocialIcons.vue